// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2c0677b8","210":"ff9d2be9","453":"d7446e4a","940":"46a88b19"}[chunkId] + ".chunk.js";
};